import DLoading from '@/components/DLoading';
import DLoaderBubbleLoading from '@/components/Global/DLoaderBubbleLoading';
import BubblePage from '@/pages/BubblePage';
import { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider, useLocation } from 'react-router-dom';
const ErrorPage = lazy(() => import('@/pages/Error'));
const EmbedPage = lazy(() => import('@/pages/EmbedPage'));
// const TooltipsPage = lazy(() => import('@/pages/TooltipsPage'))
const BubbleTooltips = lazy(() => import('@/v3/components/UI/BubbleTooltips'));
const Demo = lazy(() => import('@/pages/DemoEmbed'));
/** @type {import('react-router-dom').RouteObject[]} */
const sharedRoutes = [
  {
    path: '/',
    errorElement: (
      <>
        <ErrorPage />
      </>
    ),
    element: (
      <>
        <EmbedPage />
      </>
    ),
  },
  {
    path: '/bubble',
    errorElement: (
      <>
        <ErrorPage />
      </>
    ),
    element: (
      <>
        <BubblePage />
      </>
    ),
  },
  {
    path: '/tooltips',
    errorElement: (
      <>
        <ErrorPage />
      </>
    ),
    element: (
      <>
        <BubbleTooltips />
      </>
    ),
  },
  {
    path: '/demo',
    errorElement: (
      <>
        <ErrorPage />
      </>
    ),
    element: <Demo />,
  },
];

const routes = [...sharedRoutes];

const router = createBrowserRouter(routes, { basename: '/embed' });

const Routers = () => {
  function Fallback() {
    // This hook can only be used inside RouterProvider, so we use window.location.pathname as a workaround.
    if (typeof window !== 'undefined' && window.location.pathname.startsWith('/embed/tooltips')) {
      return null;
    }
    return <DLoaderBubbleLoading show={true} />;
  }

  return (
    <Suspense fallback={<Fallback />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};
export default Routers;
